import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "faSvg",
    values: {
      add: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "plus"],
        },
      },
      attachment: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "paperclip"],
        },
      },
      back: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "chevron-circle-left"],
        },
      },
      batch: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "layer-group"],
        },
      },
      check: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "check"],
        },
      },
      checked: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "check-square"],
        },
      },
      chart: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "chart-pie"],
        },
      },
      code: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "barcode"],
        },
      },
      contacts: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "address-book"],
        },
      },
      csv: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "file-csv"],
        },
      },
      copy: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "copy"],
        },
      },      
      compact: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "sliders-h"],
        },
      },
      date: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "calendar"],
        },
      },
      delete: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "trash"],
        },
      },
      down: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "angle-down"],
        },
      },
      letter: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "envelope"],
        },
      },
      up: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "angle-up"],
        },
      },
      right: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "angle-right"],
        },
      },
      left: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "angle-left"],
        },
      },
      download: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "download"],
        },
      },
      edit: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "pen"],
        },
      },
      error: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "exclamation-triangle"],
        },
      },
      error_alt: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "exclamation"],
        },
      },
      go: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "external-link-square-alt"],
        },
      },
      grip: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "grip-lines"],
        },
      },
      info: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "info-circle"],
        },
      },
      key: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "key"],
        },
      },
      list: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "list"],
        },
      },
      more: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "ellipsis-v"],
        },
      },
      role: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "user-tag"],
        },
      },
      clock: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "clock"],
        },
      },
      userClock: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "user-clock"],
        },
      },
      refresh: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "sync"],
        },
      },
      mapMarker: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "map-marker-alt"],
        },
      },
      next: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "angle-right"],
        },
      },      
      phone: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "phone-square"],
        },
      },
      prev: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "angle-left"],
        },
      },
      print: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "print"],
        },
      },
      search: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "search"],
        },
      },
      settings: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "cog"],
        },
      },
      sort: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "long-arrow-alt-up"],
        },
      },
      sortDown: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "long-arrow-alt-down"],
        },
      },
      sortUp: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "long-arrow-alt-up"],
        },
      },
      test: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "vial"],
        },
      },
      time: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "clock"],
        },
      },
      unchecked: {
        component: "font-awesome-icon",
        props: {
          icon: ["far", "square"],
        },
      },
      upload: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "upload"],
        },
      },
      warning: {
        component: "font-awesome-icon",
        props: {
          icon: ["fas", "exclamation-circle"],
        },
      },
    },
  },
  theme: {
    options: { customProperties: true },
    themes: {
      adi: {
        primary: "#043654",
        secondary: "#007bff",
        accent: "#7f1933",
        error: "#d72127",
        success: "#4CAF50",
      },
      nctwcs: {
        // primary: "#345270",
        // secondary: "#6592E6",
        // accent: "#67C7C5",
        primary: "#092940",
        secondary: "#6689A9",
        accent: "#922880",
        'threshold-colors-1': "#29B5D9",
        'threshold-colors-2': "#003A70",
        'threshold-colors-3': "#7A8FAA",
        'threshold-colors-4': "#C5C8C9",
        'threshold-colors-5': "#95598C"
      },
    },
  },
});
